import React from "react";

export const EstateSearchOverlay = props => (
    <div className="estate-search__overlay">
        <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
);